import { jsx as r, Fragment as D, jsxs as l } from "react/jsx-runtime";
import L, { forwardRef as M, useMemo as j } from "react";
import * as t from "@radix-ui/react-tooltip";
import B from "classnames";
import o from "./index.es2326.js";
import { Z_INDEX_TOOLTIP as E } from "./index.es174.js";
const F = {
  default: "var(--plac-lines-default)",
  brand: "var(--brand-base-60)",
  none: "transparent"
}, I = {
  brand: "var(--brand-base-0)",
  gray: "var(--plac-primary-gray)",
  white: "var(--plac-primary-white)"
}, V = M(
  ({
    defaultOpen: c = !1,
    placement: e = "top",
    align: m = "center",
    arrowPosition: i = "center",
    offset: p = 6,
    onOpenChange: d,
    testId: f,
    children: a,
    isActive: b = !0,
    delayDuration: h = 100,
    arrowWidth: v = 20,
    arrowHeight: C = 10,
    tooltipTrigger: n,
    hidePointer: g,
    open: u,
    zIndex: O = E,
    backgroundColor: _ = "gray",
    borderColor: y = "none",
    contentClassname: R,
    appendToParent: s = !1,
    disableHoverableContent: w = !1
  }, N) => {
    const P = e === "top" || e === "bottom", A = B(o.content, R, {
      [o[`arrow--${i}`]]: P && i !== "center"
    }), T = {
      zIndex: O,
      "--borderColor": F[y],
      "--backgroundColor": I[_]
    }, x = j(
      () => s ? L.Fragment : t.Portal,
      [s]
    );
    return !b || !a ? /* @__PURE__ */ r(D, { children: n }) : /* @__PURE__ */ l(
      t.Root,
      {
        open: u,
        defaultOpen: c,
        onOpenChange: d,
        delayDuration: h,
        disableHoverableContent: w,
        "aria-label": "tooltip",
        children: [
          /* @__PURE__ */ r(t.Trigger, { asChild: !0, id: "primitive-tooltip-internal-trigger", ref: N, children: n }),
          /* @__PURE__ */ r(x, { children: /* @__PURE__ */ l(
            t.Content,
            {
              className: A,
              side: e,
              sideOffset: p,
              align: m,
              style: T,
              "data-testid": f || "primitive-tooltip-content",
              "pl-data-identifier": "primitive-tooltip-content",
              children: [
                a,
                !g && /* @__PURE__ */ r(
                  t.Arrow,
                  {
                    className: o.arrow,
                    height: C,
                    width: v
                  }
                )
              ]
            }
          ) })
        ]
      }
    );
  }
);
export {
  V as PrimitiveTooltip
};
//# sourceMappingURL=index.es2321.js.map
